module.exports = __webpack_public_path__ + "img/tpc-30.2c13efa3.webp";